import React, {useEffect, useState} from 'react';
import styles from './ClientFooter.module.css';
import TermPopUp from "../../common/term/TermPopUp";
import PolicyPopUp from "../../common/term/PolicyPopUp";
import {getPolicyAPI, getTermAPI} from "../../../services/term";

interface FooterProps {
    className?: string;
}

//클라이언트 푸터
const ClientFooter: React.FC<FooterProps> = ({className}) => {
    const [showTerm, setShowTerm] = useState(false);
    const [showPolicy, setShowPolicy] = useState(false);
    const [term, setTerm] = useState("");
    const [policy, setPolicy] = useState("");

    //데이터 사업 규정
    const fetchTerm = async () => {
        try {
            //데이터 사업 규정 조회 API
            const term = await getTermAPI();
            setTerm(term);
        } catch (error) {
            console.error('Failed to fetch term:', error);
        }
    }

    //개인정보 처리 규정
    const fetchPolicy = async () => {
        try {
            //개인정보 처리 규정 조회 API
            const policy = await getPolicyAPI();
            setPolicy(policy);
        } catch (error) {
            console.error('Failed to fetch policy:', error);
        }
    }

    useEffect(() => {
        fetchPolicy();
        fetchTerm();
    }, []);

    return (
        <>
            <footer className={`${styles.footer} ${className || ''}`}>
                <div className={styles.topContainer}>
                    <div className={styles.covi}>
                        코드비전 주식회사
                        <p className={styles.copyrightM}>© CODEVISION Inc.</p>
                    </div>
                    <div className={styles.links}>
                        {/*데이터 사업 규정 버튼*/}
                        <button
                            className={styles.link}
                            onClick={() => setShowTerm(true)}
                        >
                            Terms of use
                        </button>
                        <span className={styles.separator}>·</span>
                        {/*개인정보 처리 규정 버튼*/}
                        <button
                            className={styles.link}
                            onClick={() => setShowPolicy(true)}
                        >
                            Privacy policy
                        </button>
                    </div>
                </div>
                <div className={styles.middleContainer}>
                    <p><strong>대표자</strong> <br className={styles.mobileReturn}/> 송응열</p>
                    <p><strong>유선번호</strong> <br className={styles.mobileReturn}/> 02-2088-6624</p>
                    <p><strong>E-mail</strong> <br className={styles.mobileReturn}/> data@codevision.ai</p>
                </div>
                <div className={styles.bottomContainer}>
                    <div className={styles.bottomLeft}>
                        <div className={styles.bottomAddressContainer}>
                            <div className={styles.coviInfo}>
                                <p>사업장 소재지</p>
                            </div>
                            <div className={styles.coviInfoValue}>
                                <p>서울특별시 서대문구 연세로2나길 61, 304호<br/> (창천동, 캠퍼스타운 에스큐브)</p>
                            </div>
                        </div>
                        <div className={styles.bottomLeftContainer}>
                            <div className={styles.coviInfo}>
                                <p>사업자등록번호</p>
                            </div>
                            <div className={styles.coviInfoValue}>
                                <p>446-87-01152</p>
                            </div>
                        </div>
                        <div className={styles.bottomLeftContainer}>
                            <div className={styles.coviInfo}>
                                <p>통신판매업 신고번호</p>
                            </div>
                            <div className={styles.coviInfoValue}>
                                <p>제2024-서울서대문-1379호</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.bottomRight}>
                        <p className={styles.copyright}>© CODEVISION Inc.</p>
                    </div>
                </div>
            </footer>
            {/*개인정보 처리 규정 팝업*/}
            {showTerm && (
                <TermPopUp
                    term={term}
                    onClose={() => {
                        setShowTerm(false);
                    }}
                />
            )}
            {/*개인정보 처리 규정 팝업*/}
            {showPolicy && (
                <PolicyPopUp
                    policy={policy}
                    onClose={() => {
                        setShowPolicy(false);
                    }}
                />
            )}
        </>
    );
};

export default ClientFooter;